import { domainConsultationPlan } from "@@@/planCatalog/domainPlans";
import { DomainFlowState } from "../types/DomainFlowState";

/**
 * Returns a consultation plan option if deferred-with-consultation.
 */
export function injectConsultationPlan(
    state: DomainFlowState
) {
    return state === "deferred-with-consultation"
        ? domainConsultationPlan
        : null;
}